import { useState } from 'react';
import type { MouseEvent, ReactElement } from 'react';

import { IconArrowRight } from '@xing-com/icons';
import { BREAKPOINTS, useMediaListener } from '@xing-com/util';

import { PerkListMobile } from '../../../perk-list-mobile';

import * as Styled from './card-discover-button.styled';
import type { CardDiscoverButtonProps } from './card-discover-button.types';

export type { CardDiscoverButtonProps } from './card-discover-button.types';

type MobileDiscoverButtonProps = Omit<
  CardDiscoverButtonProps,
  'detailsUrl' | 'onDiscover'
>;

const MobileDiscoverButton = ({
  discover,
  onFeatureDiscovery,
  ...perkListProps
}: MobileDiscoverButtonProps): ReactElement => {
  const [isPerkListShown, setIsPerkListShown] = useState(false);

  return (
    <>
      <Styled.DiscoverAction
        type="button"
        size="medium"
        icon={IconArrowRight}
        iconAfter
        onClick={() => {
          onFeatureDiscovery?.();
          setIsPerkListShown(true);
        }}
      >
        {discover}
      </Styled.DiscoverAction>
      <PerkListMobile
        {...perkListProps}
        isShown={isPerkListShown}
        onClose={() => setIsPerkListShown(false)}
      />
    </>
  );
};

export const CardDiscoverButton = ({
  detailsUrl,
  discover,
  onDiscover,
  onFeatureDiscovery,
  ...perkListProps
}: CardDiscoverButtonProps): ReactElement => {
  const matchedMedia = useMediaListener();
  const isSmallScreen = matchedMedia === BREAKPOINTS.handheld;
  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    onFeatureDiscovery?.();
    onDiscover();
  };

  if (isSmallScreen) {
    return (
      <MobileDiscoverButton
        discover={discover}
        onFeatureDiscovery={onFeatureDiscovery}
        {...perkListProps}
      />
    );
  }

  return (
    <Styled.DiscoverAction
      href={detailsUrl}
      onClick={handleClick}
      size="medium"
      icon={IconArrowRight}
      iconAfter
    >
      {discover}
    </Styled.DiscoverAction>
  );
};
